module.exports = __webpack_public_path__ + "static/media/events.402377f2.svg";